import { RG_TYPE as a } from "@project-rouge/rg-core";
import { getCountOfType as c } from "../../metrics/counting/index.js";
import { getLevelAmenitiesArea as f } from "../../metrics/scalar-metrics/level-metrics/index.js";
import { getLevelAmenitiesPerimeter as p } from "../../metrics/scalar-metrics/level-metrics/index2.js";
import { getLevelAmenitiesWallArea as i } from "../../metrics/scalar-metrics/level-metrics/index3.js";
import { getLevelArea as o } from "../../metrics/scalar-metrics/level-metrics/index4.js";
import { getLevelBaseBuildDoubleDoorsCount as C } from "../../metrics/scalar-metrics/level-metrics/index5.js";
import { getLevelBaseBuildMiscDoorsCount as v } from "../../metrics/scalar-metrics/level-metrics/index6.js";
import { getLevelBaseBuildSingleDoorsCount as A } from "../../metrics/scalar-metrics/level-metrics/index7.js";
import { getLevelBaseBuildWallArea as L } from "../../metrics/scalar-metrics/level-metrics/index8.js";
import { getLevelClearInternalHeight as B } from "../../metrics/scalar-metrics/level-metrics/index9.js";
import { getLevelCommercialArea as l } from "../../metrics/scalar-metrics/level-metrics/index10.js";
import { getLevelCommercialPerimeter as x } from "../../metrics/scalar-metrics/level-metrics/index11.js";
import { getLevelCommercialWallArea as h } from "../../metrics/scalar-metrics/level-metrics/index12.js";
import { getLevelCountNorthFacingUnits as D } from "../../metrics/scalar-metrics/level-metrics/index13.js";
import { getLevelDoubleDoorsCount as S } from "../../metrics/scalar-metrics/level-metrics/index14.js";
import { getLevelEfficiency as W } from "../../metrics/scalar-metrics/level-metrics/index15.js";
import { getLevelFacadeExternalCornerLength as g } from "../../metrics/scalar-metrics/level-metrics/index16.js";
import { getLevelFacadeInternalCornerLength as P } from "../../metrics/scalar-metrics/level-metrics/index17.js";
import { getLevelFfl as y } from "../../metrics/scalar-metrics/level-metrics/index18.js";
import { getLevelGEA as F } from "../../metrics/scalar-metrics/level-metrics/index19.js";
import { getLevelGIA as E } from "../../metrics/scalar-metrics/level-metrics/index20.js";
import { getLevelGlazedFacadeArea as R } from "../../metrics/scalar-metrics/level-metrics/index21.js";
import { getLevelGrossFacadeArea as T } from "../../metrics/scalar-metrics/level-metrics/index22.js";
import { getLevelMiscDoorsCount as G } from "../../metrics/scalar-metrics/level-metrics/index23.js";
import { getLevelNetFacadeArea as I } from "../../metrics/scalar-metrics/level-metrics/index24.js";
import { getLevelNIA as M } from "../../metrics/scalar-metrics/level-metrics/index25.js";
import { getLevelNonResidentialArea as N } from "../../metrics/scalar-metrics/level-metrics/index26.js";
import { getLevelPerimeter as m } from "../../metrics/scalar-metrics/level-metrics/index27.js";
import { getLevelPodiumHeight as H } from "../../metrics/scalar-metrics/level-metrics/index28.js";
import { getLevelResidentialEfficiency as O } from "../../metrics/scalar-metrics/level-metrics/index29.js";
import { getLevelServicesArea as U } from "../../metrics/scalar-metrics/level-metrics/index30.js";
import { getLevelServicesPerimeter as z } from "../../metrics/scalar-metrics/level-metrics/index31.js";
import { getLevelServicesWallArea as u } from "../../metrics/scalar-metrics/level-metrics/index32.js";
import { getLevelSingleDoorsCount as j } from "../../metrics/scalar-metrics/level-metrics/index33.js";
import { getLevelUnitToLiftCoreRatio as V } from "../../metrics/scalar-metrics/level-metrics/index34.js";
import { getLevelVerticalWallArea as n } from "../../metrics/scalar-metrics/level-metrics/index35.js";
import { getFireCoreCount as Y } from "../../metrics/scalar-metrics/total-metrics/index20.js";
import { getLiftCoreCount as _ } from "../../metrics/scalar-metrics/total-metrics/index31.js";
import { getRgObjectsAtLevel as s } from "../../utils/rg-util/index3.js";
import { buildingMetrics as t } from "./index.js";
function Te(r, e) {
  return {
    floor: e,
    metrics: [
      { name: t.gea, value: F(r, e), unit: "m\xB2" },
      { name: t.gia, value: E(r, e), unit: "m\xB2" },
      { name: t.nia, value: M(r, e), unit: "m\xB2" },
      { name: t.nonResidentialArea, value: N(r, e), unit: "m\xB2" },
      { name: t.facadeGrossArea, value: T(r, e), unit: "m\xB2" },
      { name: t.facadeNetArea, value: I(r, e), unit: "m\xB2" },
      { name: t.facadeInternalCornersLength, value: P(r, e), unit: "m" },
      { name: t.facadeExternalCornersLength, value: g(r, e), unit: "m" },
      { name: t.facadeGlazedArea, value: R(r, e), unit: "m\xB2" },
      { name: t.roofArea, value: o(r, e, [a.Roof]), unit: "m\xB2" },
      { name: t.flightsOfStairs, value: s(r, a.Core, e).length, unit: "unitless" },
      { name: t.doubleDoorCount, value: S(r, e), unit: "unitless" },
      { name: t.singleDoorCount, value: j(r, e), unit: "unitless" },
      { name: t.miscDoorCount, value: G(r, e), unit: "unitless" },
      { name: t.baseBuildDoubleDoorCount, value: C(r, e), unit: "unitless" },
      { name: t.baseBuildSingleDoorCount, value: A(r, e), unit: "unitless" },
      { name: t.baseBuildMiscDoorCount, value: v(r, e), unit: "unitless" },
      { name: t.coreCount, value: s(r, a.Core, e).length, unit: "unitless" },
      { name: t.liftCoreCount, value: _(r, e), unit: "unitless" },
      { name: t.fireCoreCount, value: Y(r, e), unit: "unitless" },
      { name: t.moduleCount, value: c(r, a.Module, e), unit: "unitless" },
      { name: t.efficiency, value: W(r, e), unit: "unitless" },
      { name: t.residentialEfficiency, value: O(r, e), unit: "unitless" },
      { name: t.ffl, value: y(r, e), unit: "m" },
      { name: t.emptySpaceArea, value: o(r, e, [a.EmptySpace]), unit: "m\xB2" },
      { name: t.commercialArea, value: l(r, e), unit: "m\xB2" },
      { name: t.commercialPerimeter, value: x(r, e), unit: "m" },
      { name: t.commercialSpacesWallArea, value: h(r, e), unit: "m\xB2" },
      { name: t.amenitiesArea, value: f(r, e), unit: "m\xB2" },
      { name: t.amenitiesPerimeter, value: p(r, e), unit: "m" },
      { name: t.amenityTechSpacesWallArea, value: i(r, e), unit: "m\xB2" },
      { name: t.servicesArea, value: U(r, e), unit: "m\xB2" },
      { name: t.servicesPerimeter, value: z(r, e), unit: "m" },
      { name: t.serviceTechSpacesWallArea, value: u(r, e), unit: "m\xB2" },
      { name: t.coreArea, value: o(r, e, [a.Core]), unit: "m\xB2" },
      { name: t.corePerimeter, value: m(r, e, [a.Core]), unit: "m" },
      { name: t.coreWallArea, value: n(r, e, [a.Core]), unit: "m\xB2" },
      { name: t.corridorArea, value: o(r, e, [a.Corridor]), unit: "m\xB2" },
      { name: t.corridorPerimeter, value: m(r, e, [a.Corridor]), unit: "m" },
      { name: t.corridorWallArea, value: n(r, e, [a.Corridor]), unit: "m\xB2" },
      { name: t.coreAndCorridorArea, value: o(r, e, [a.Core, a.Corridor]), unit: "m\xB2" },
      { name: t.coreAndCorridorPerimeter, value: m(r, e, [a.Core, a.Corridor]), unit: "m" },
      { name: t.coreAndCorridorWallArea, value: n(r, e, [a.Core, a.Corridor]), unit: "m\xB2" },
      { name: t.serviceTechSpacesWallArea, value: u(r, e), unit: "m\xB2" },
      { name: t.amenityTechSpacesWallArea, value: i(r, e), unit: "m\xB2" },
      { name: t.baseBuildWallArea, value: L(r, e), unit: "m\xB2" },
      { name: t.countNorthFacingUnits, value: D(r, e), unit: "unitless" },
      { name: t.unitToLiftCoreRatio, value: V(r, e), unit: "unitless" },
      { name: t.podiumHeight, value: H(r, e), unit: "m" },
      { name: t.clearInternalHeight, value: B(r, e), unit: "m" }
    ]
  };
}
export {
  Te as getStoryMetricsForLevel
};
//# sourceMappingURL=index5.js.map
